enum UserFieldsNameEnum {
  WORK_EMAIL = "workEmail",
  TYPE = "type",
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  JOB_TITLE = "jobTitle",
  USER_ROLES = "userRoles",
  LANGUAGE_TYPE = "languageType"
}

export default UserFieldsNameEnum;
